// Custom error classes for API handling
export class APIError extends Error {
    constructor(message, status, response) {
        super(message);
        this.name = 'APIError';
        this.status = status;
        this.response = response;
    }
}

export class NetworkError extends Error {
    constructor(message) {
        super(message);
        this.name = 'NetworkError';
    }
}

export class TimeoutError extends Error {
    constructor(message) {
        super(message);
        this.name = 'TimeoutError';
    }
}

// Error handler utility
export const handleAPIError = (error) => {
    console.log("error", error);

    if (error instanceof APIError) {
        return {
            type: 'API_ERROR',
            message: error.message,
            status: error.status,
            response: error.response,
            code: error.response?.data?.code ?? null,
        };
    }

    if (error instanceof NetworkError) {
        return {
            type: 'NETWORK_ERROR',
            message: 'Network connection failed. Please check your internet connection.',
        };
    }

    if (error instanceof TimeoutError) {
        return {
            type: 'TIMEOUT_ERROR',
            message: 'Request timed out. Please try again.',
        };
    }

    return {
        type: 'UNKNOWN_ERROR',
        message: 'An unexpected error occurred. Please try again.',
    };
};
